import * as Sentry from '@sentry/react';

export function error(err: unknown, msg?: string) {
  if (msg) {
    console.error(msg);
    Sentry.captureMessage(msg);
  }
  Sentry.captureException(err);
  console.error(err);
}
